<template>
	<div tabindex="0" @keyup.esc="closeAdd()" class="hide-outline">
		<TopPanel
			:units="['checklista', 'checklistor', 'Ny checklista']"
			:pagination="pagination"
			:showCustomer="true"
			:customerOverride="true"
			:orderBys="orderBys"
			:orderBy="searchParams.orderBy"
			:hide-add="!$isAllowedTo('checklists_edit')"
			@toggleAdd="navigate"
			@search="search"
			@orderBy="orderBy"
		/>
		<main class="main-view columns">
			<ChecklistList
				:questionLists="questionLists"
				@delete="askToDelete"
				@edit="edit"
				@search="getQuestionLists"
			/>
		</main>
		<DeleteModal
			v-if="showDelete"
			@confirm="deleteSelected"
			@cancel="cancelDelete"
			:message="deleteMessage"
		/>
		<ErrorModal
			v-if="displayErrorModal"
			:errors="errors"
			@closeModal="closeErrorModal"
		/>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import ChecklistList from './components/ChecklistList';
import DeleteModal from '@/components/DeleteModal';
import TopPanel from '@/components/TopPanel';
import ErrorModal from '@/components/ErrorModal';

export default {
	components: {
		ChecklistList,
		DeleteModal,
		TopPanel,
		ErrorModal
	},

	data() {
		return {
			showDelete: false,
			selectedQuestionList: {},
			orderBys: [
				{ name: 'Namn', value: 'Name' },
				{ name: 'Skapad', value: 'Created' }
			],
			errors: [],
			displayErrorModal: false
		};
	},

	computed: {
		...mapState('questionListStore', ['searchParams']),
		...mapGetters('questionListStore', ['questionLists', 'pagination']),
		...mapGetters('customerStore', ['dropdownCustomers']),
		...mapGetters('appStore', ['isMobile']),
		...mapGetters('user', ['getActiveCustomer']),

		deleteMessage() {
			return this.selectedQuestionList.description
				? `Är du säker på att du vill ta bort ${this.selectedQuestionList.description}?`
				: '';
		}
	},

	watch: {
		'getActiveCustomer.id'() {
			this.searchParams.customerId = this.getActiveCustomer?.id;
			this.getQuestionLists();
		}
	},

	methods: {
		...mapActions('questionListStore', ['getQuestionLists','deleteQuestionList']),

		navigate() {
			let id = this.selectedQuestionList.id || 0;
			this.$router.push({
				name: 'ChecklistDetailView',
				params: {
					checklistId: id
				}
			});
		},

		edit(questionList) {
			Object.assign(this.selectedQuestionList, questionList);
			this.navigate();
		},

		askToDelete(questionList) {
			this.showAdd = false;
			Object.assign(this.selectedQuestionList, questionList);
			this.showDelete = true;
		},

		cancelDelete() {
			this.showDelete = false;
			this.selectedQuestionList = {};
		},

		deleteSelected() {
			this.deleteQuestionList(this.selectedQuestionList).then(res => {
				this.showDelete = false;
				this.selectedQuestionList = {};

				if (res.status === 200 && !res.data.success) {
					this.errors = res.data.errors;
					this.displayErrorModal = true;
				}
			});
		},

		search(searchValue) {
			this.searchParams.search = searchValue;
			this.getQuestionLists();
		},

		orderBy(orderBy) {
			this.searchParams.orderBy = orderBy;
			this.getQuestionLists();
		},

		closeErrorModal() {
			this.displayErrorModal = false;
			this.errors = [];
		}
	},

	created() {
		this.searchParams.customerId = this.getActiveCustomer?.id;
		this.searchParams.companyId = this.getActiveCompany?.id;
		this.getQuestionLists();
	}
};
</script>
